import { render, staticRenderFns } from "./OutstandingBids.vue?vue&type=template&id=07f6df1d&"
import script from "./OutstandingBids.vue?vue&type=script&lang=js&"
export * from "./OutstandingBids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports